export class StripeUtil {
  static shouldUseTestCredentials(ownersEmail: string): boolean {
    return ownersEmail.endsWith('@test.dev.optitax.ca') || ownersEmail.endsWith('@test.optitax.ca');
  }
}